module.exports = __webpack_public_path__ + "front/img/bg-success.2f90cea8.png";